'use client';

import { useRouter } from 'next/navigation';
import { useEffect, useState } from 'react';

import { Loading } from '@/app/components/Loading';
import { getTinyFullURL } from '@/utils/actions/getTinyFullURL';

import { Error } from '../../components/Error';

interface TinyURLWrapperProps {
  tinyURL: string;
}

export function TinyURLWrapper({ tinyURL }: TinyURLWrapperProps) {
  const router = useRouter();
  const [error, setError] = useState<string | undefined>(undefined);

  useEffect(() => {
    const fetchURL = async () => {
      const result = await getTinyFullURL({ tinyURL });

      if ([404, 410, 422].includes(result.statusCode)) {
        setError(result.error);
      } else if (result.data?.fullURL) {
        router.push(result.data.fullURL);
      } else {
        setError('Unknown error.');
      }
    };

    fetchURL();
  }, [tinyURL, router]);

  if (error)
    return <Error heading={error} subheading={`Please check the URL or try again later.`} />;

  return <Loading>{`Please wait while we're redirecting you.`}</Loading>;
}
